// extracted by mini-css-extract-plugin
module.exports = {"extendedContentContainer":"ExtendedHtmlContentContainer_extendedContentContainer__13gCH","contentView":"ExtendedHtmlContentContainer_contentView__2b39-"};